import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";

const TESTIMONIALS = [
  {
    name: "Karim B.",
    role: "Conducteur — FIMO Marchandises",
    text: "Une formation complète et des formateurs vraiment à l'écoute. J'ai obtenu ma qualification et trouvé un poste dans la foulée. Le simulateur et les véhicules sont au top.",
  },
  {
    name: "Sandra M.",
    role: "Enseignante — TP ECSR",
    text: "L'accompagnement du début à la fin a fait toute la différence. L'équipe m'a aidée à monter mon dossier de financement et à réussir mon titre professionnel.",
  },
  {
    name: "Thomas R.",
    role: "Conducteur — Permis CE",
    text: "Centre sérieux, matériel récent et pédagogie claire. Je recommande à toute personne qui veut se former sérieusement aux métiers du transport.",
  },
  {
    name: "Aïcha D.",
    role: "Conductrice — FCO Voyageurs",
    text: "Le renouvellement de ma FCO s'est déroulé dans d'excellentes conditions. Formation dense mais très bien organisée sur les 5 jours.",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const prev = () => setI((p) => (p - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setI((p) => (p + 1) % TESTIMONIALS.length);
  const t = TESTIMONIALS[i];

  return (
    <section id="temoignages" className="bg-brand-blue py-24 lg:py-32" data-testid="testimonials">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8">
        <Reveal className="max-w-3xl">
          <span className="font-display text-sm font-extrabold uppercase tracking-[0.2em] text-brand-red-light">Témoignages</span>
          <h2 className="mt-3 font-display text-4xl font-black uppercase leading-[0.98] tracking-[-0.03em] text-white sm:text-5xl">
            Ils ont réussi avec Educaser
          </h2>
        </Reveal>

        <div className="relative mt-14 rounded-3xl bg-white p-8 sm:p-14">
          <Quote className="h-12 w-12 text-brand-red" />
          <div className="min-h-[180px]">
            <AnimatePresence mode="wait">
              <motion.div
                key={i}
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -30 }}
                transition={{ duration: 0.4 }}
              >
                <p className="mt-4 font-display text-2xl font-bold leading-snug tracking-tight text-brand-blue sm:text-3xl">
                  {t.text}
                </p>
                <div className="mt-8 flex items-center gap-4">
                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-blue font-display text-lg font-bold text-white">
                    {t.name.charAt(0)}
                  </div>
                  <div>
                    <p className="font-bold text-brand-blue">{t.name}</p>
                    <p className="text-sm text-slate-500">{t.role}</p>
                  </div>
                  <div className="ml-auto hidden items-center gap-1 text-brand-red sm:flex">
                    {[...Array(5)].map((_, s) => <Star key={s} className="h-4 w-4 fill-current" />)}
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="mt-8 flex items-center gap-3 border-t border-slate-100 pt-6">
            <button onClick={prev} className="flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 text-brand-blue transition-colors hover:bg-brand-blue hover:text-white" aria-label="Précédent" data-testid="testimonial-prev">
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button onClick={next} className="flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 text-brand-blue transition-colors hover:bg-brand-blue hover:text-white" aria-label="Suivant" data-testid="testimonial-next">
              <ChevronRight className="h-5 w-5" />
            </button>
            <div className="ml-3 flex gap-1.5">
              {TESTIMONIALS.map((_, d) => (
                <span key={d} className={`h-2 rounded-full transition-all ${d === i ? "w-6 bg-brand-red" : "w-2 bg-slate-300"}`} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
